<template>
  <section class="panel">
    <el-tabs v-model="activeType" @tab-click="search">
      <el-tab-pane label="系列分类" name="SERIES" />
      <el-tab-pane label="型号分类" name="MODEL" />
      <el-tab-pane label="性能分类" name="PERFORMANCE" />
    </el-tabs>
    <div class="toolbar">
      <el-input v-model="query.keyword" placeholder="分类名称" clearable style="width:200px" />
      <el-button class="btn-search" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="open()">新增分类</el-button>
    </div>
    <el-table :data="page.records" border size="small">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="分类名" min-width="180" />
      <el-table-column prop="sort" label="排序" width="90" />
      <el-table-column label="状态" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 'ENABLED' ? 'success' : 'info'" size="small">
            {{ statusText(row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="{ row }">
          <el-button size="mini" class="btn-edit" icon="el-icon-edit" @click="open(row)">编辑</el-button>
          <el-button size="mini" type="danger" icon="el-icon-delete" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :current-page="page.page"
      :page-size="page.size"
      :page-sizes="[10, 20, 50, 100]"
      :total="page.total"
      @size-change="size => { query.size = size; search() }"
      @current-change="p => { query.page = p; load() }"
    />

    <el-dialog :title="form.id ? '编辑分类' : '新增分类'" :visible.sync="dialog" width="520px">
      <el-form label-position="top">
        <el-form-item label="名称"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="排序"><el-input-number v-model="form.sort" :min="0" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="启用" value="ENABLED" />
            <el-option label="禁用" value="DISABLED" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog = false">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import http from '../api'

const blankPage = { total: 0, page: 1, size: 10, records: [] }
const statusText = { ENABLED: '启用', DISABLED: '禁用' }

export default {
  data() {
    return {
      activeType: 'SERIES',
      query: { page: 1, size: 10 },
      page: { ...blankPage },
      dialog: false,
      form: {}
    }
  },
  mounted() {
    this.load()
  },
  methods: {
    statusText(status) {
      return statusText[status] || status || '-'
    },
    async load() {
      this.page = await http.get('/admin/categories/page', { params: { ...this.query, categoryType: this.activeType } })
    },
    search() {
      this.query.page = 1
      this.load()
    },
    open(row) {
      this.form = row ? { ...row } : { parentId: 0, level: 1, categoryType: this.activeType, sort: 100, status: 'ENABLED' }
      this.dialog = true
    },
    async save() {
      this.form.parentId = 0
      this.form.level = 1
      this.form.categoryType = this.activeType
      if (this.form.id) {
        await http.put(`/admin/categories/${this.form.id}`, this.form)
      } else {
        await http.post('/admin/categories', this.form)
      }
      this.dialog = false
      this.load()
    },
    async remove(row) {
      await this.$confirm('确认删除该分类？')
      await http.delete(`/admin/categories/${row.id}`)
      this.load()
    }
  }
}
</script>
